/**
 * Lecture d'un refus des routes `/api/workflows` pour l'éditeur d'automatisations et pour son
 * catalogue (`useWorkflowEditor.ts`, `useEventCatalog.ts`) : une seule règle, lue par les deux.
 *
 * Le `code` structuré du serveur est gardé ; à défaut (corps illisible, code `UNKNOWN`), le
 * statut HTTP en tient lieu (`HTTP_403`). Recopiée dans chaque hook, la règle dériverait au
 * premier correctif de l'une des copies.
 */
import i18n from '@/i18n';
import { extractStructuredApiError } from '@/lib/api-error';

/**
 * `lang=<langue de l'interface>`, pour `PATCH …/activate` : le refus d'activation
 * (`422 WORKFLOW_ACTIVATE_INVALID`) s'écrit dans cette langue (`_phrases_d_activation.py`), et
 * l'éditeur comme la liste l'affichent tel quel. Sans lui, le serveur suivrait l'`Accept-Language`
 * du NAVIGATEUR, pas la langue choisie dans Argalis.
 */
export function langueDuRefus(): string {
  return `lang=${encodeURIComponent(i18n.language || 'fr')}`;
}

export async function readError(resp: Response): Promise<Error & { code?: string }> {
  let payload: unknown = {};
  try {
    payload = await resp.json();
  } catch {
    /* corps illisible : le statut suffit */
  }
  const { message, code } = extractStructuredApiError(payload);
  const err = new Error(message || `Erreur ${resp.status}`) as Error & { code?: string };
  err.code = code && code !== 'UNKNOWN' ? code : `HTTP_${resp.status}`;
  return err;
}
